import useAxios from "@src/utility/hooks/use-axios";
import { useState } from "react";

// ** Custom Hooks
// ** Toastify (if needed, import and use inside as required)

const useImageUpload = ({ methods, url }) => {
    const [formData, setFormData] = useState(null);
    const [image, setImage] = useState(null);
    const { setValue, trigger } = methods;
    const { loading, axiosInstance } = useAxios({
        base: "panel"
    });
    /**
     * It takes the image file selected by the user, creates a new FormData object, appends the image to
     * the FormData object, and then sets the state of the formData and image variables to the new
     * FormData object and the URL of the image file, respectively
     * @param event - the event that is passed in from the event listener
     */
    const handleImageSelect = async event => {
        if (typeof event === "object" && event?.target?.files) {
            const selectedImage = event.target.files[0];
            event.target.value = "";
            const newFormData = new FormData();
            newFormData.append("pp", selectedImage);
            setFormData(newFormData);
            setImage(URL.createObjectURL(selectedImage));
            setValue("image", selectedImage, { shouldDirty: true });
            const { data } = await axiosInstance.patch(url, newFormData);
            setImage(data.pp);
        } else {
            setImage(null);
            setValue("image", "", { shouldDirty: true });
        }
        trigger("image");
    };
    return {
        handleImageSelect,
        setImage,
        image,
        formData,
        loading
    };
};

export default useImageUpload;
